import {Nestable} from "./summary";

export type SiteType = "Customer self-build" | "Opportunity" | "Edge" | "Competitor" | "Customer Early Stage" | "Early Stage" | "Land Banked";

export const PRODUCT_TYPES = {
  AVAILABILITY_ZONE: 'Availability Zone'
} as const;

export type ProductType =
  | typeof PRODUCT_TYPES.AVAILABILITY_ZONE
  | "AI/ML"
  | "Local Zone"
  | "Enterprise"
  | "Internet Exchange"
  | "Edge"
  | "Wavelength Zone"
  | "Ground Station";


export interface Datacenter extends DatacenterBasicInfo, Nestable {
  auxId?: number;
  mwTotal: number;
  dataHallUC: number;
  dataHallPlanned: number;
  dataHallTotal: number;
  buildingAreaLive: number;
  buildingAreaUC: number;
  buildingAreaPlanned: number;
  address: string;
  imageBase64?: string | null;
}

export interface DatacenterBasicInfo {
  locationId?: String;
  tempId?: String;
  mapId: string;
  country: string;
  market: string;
  provider: string;
  mwLive: number;
  mwUC: number;
  mwPlanned: number;
  dataHallLive: number;
  buildingAreaTotal: number;
  lon: number;
  lat: number;
  highligth?: boolean;
  isHidden?: boolean;
  firstYearOp: string;
  building: string;
  area: string;
  selected?: boolean;
  notes: string;
  productType: ProductType[];
  availabilityZoneId?: string | null;
  sellableITLoad: number;
  campus?: string;
  buildingTenant?: string[];
  creationDate?: string;
  modificationDate?: string;
  modifiedBy?: string;
  color?: string;
  imageBase64?: string | null;
  siteType: SiteType[];
  address?: string;
  dataSource?: string[];
  weightedAverageLeaseTermYears?: number;
  parcelSizeAcres?: number;
  toUpdate?: boolean;
  toDelete?: boolean;
}
